import { bulkInsertFileAssociations } from '../../../common/BFF/BFF_files/bulkInsertFileAssociations'
import { addFile } from '../../../common/BFF/BFF_files/addFile'
import { REACT_APP_IMG } from '../../../common/config'
import { isMobile } from 'react-device-detect'

export function loadWebSignForVerificationForClientPDF(w, isForClient, webSignConfigVerificationForClientPDF, requestId ) {
  if (!w) return false
  if (!isForClient) return true
  if (!webSignConfigVerificationForClientPDF) return true

  // firma digital no disponible en versión Mobile
  if (isMobile) return true

  // si el doc todavía no está listo, el padre reintenta
  try {
    if (!w.document || !w.document.body) return false
  } catch (e) {
    return false
  }

    const printBtn = w.document.querySelector('.fab-action--print')
    if (!printBtn) return false

    if (w.document.querySelector('.fab-action--sign')) return true

    const signBtn = w.document.createElement('div')
    signBtn.className = 'fab-action--sign'
    signBtn.title = 'Firmar'
    signBtn.innerHTML = '✎'

    const parent = printBtn.parentElement
    parent.insertBefore(signBtn, printBtn.nextSibling)

    const styleAlready = w.document.getElementById('asofix-sign-style')
    if (!styleAlready) {
    const style = w.document.createElement('style')
    style.id = 'asofix-sign-style'
    style.textContent = `
      .fab-action--sign{
        width:56px;height:56px;border-radius:50%;
        background:#1976d2;color:#fff;
        display:flex;align-items:center;justify-content:center;
        font-size:24px;
        cursor:pointer;
        box-shadow:0 8px 16px rgba(0,0,0,.25);
        user-select:none;
        margin-right:12px;
      }
    `
    w.document.head.appendChild(style)
  }

    signBtn.addEventListener('click', async () => {
      const loadScript = (src) =>
        new Promise((resolve, reject) => {
          const existing = w.document.querySelector(`script[src="${src}"]`)
          if (existing) return resolve()
          const s = w.document.createElement('script')
          s.src = src
          s.async = true
          s.onload = resolve
          s.onerror = reject
          w.document.head.appendChild(s)
        })

      try {
        if (!w.html2pdf) {
          await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js')
        }
        if (!w.html2pdf) {
          console.error('No se pudo cargar html2pdf')
          return
        }

        let pdfBlob

        try {
          // 1) agarramos el contenedor real del informe
          const sourceEl = w.document.querySelector('.container') || w.document.body

          // 2) clon del informe (sin FABs)
          const clone = sourceEl.cloneNode(true)
          clone.querySelectorAll('.fab-actions, .fab-action--print, .fab-action--sign').forEach((el) => el.remove())

          // 3) wrapper
          const wrapper = w.document.createElement('div')
          wrapper.appendChild(clone)
          wrapper.style.display = 'inline-block'
          wrapper.style.width = 'max-content'

          w.document.body.appendChild(wrapper)

          // Medidas reales del contenido en px
          const wrapperScroll = wrapper
          const pxW = wrapperScroll.scrollWidth
          const pxH = wrapperScroll.scrollHeight

          // orientación dinámica según contenido
          const isLandscape = pxW > pxH
          const orientation = isLandscape ? 'landscape' : 'portrait'

          // Convertimos px
          const pxToMm = (px) => px * 0.2645833333
          const mmW = pxToMm(pxW)
          const mmH = pxToMm(pxH)

          const opt = {
            margin: 0,
            html2canvas: { scale: 2, scrollX: 0, scrollY: 0, backgroundColor: '#fff' },
            jsPDF: { unit: 'mm', format: [mmW, mmH], orientation },
          }

          // renderizacion
          const worker = w.html2pdf().set(opt).from(wrapper)
          const pdf = await worker.toPdf().get('pdf')

          // elimina páginas extra en blanco (si existe)
          try {
            const n = pdf.getNumberOfPages()
            if (n > 1) {
              const last = pdf.internal?.pages?.[n]
              const lastLen = Array.isArray(last) ? last.join('').trim().length : 0
              if (lastLen < 200) pdf.deletePage(n)
            }
          } catch (e) {
            console.error('[PDF] no se pudo evaluar/borrar última página', e)
          }

          pdfBlob = pdf.output('blob')

          // limpia el wrapper para no ensuciar el DOM
          try {
            wrapper.remove()
          } catch (e) {
            console.error('[PDF] no se pudo remover wrapper', e)
          }
        } catch (e) {
          console.error('[PDF] error', e)
        }

        if (!pdfBlob) {
          console.error('No se pudo generar el PDF')
          return
        }

        // 3) PDF Blob -> File
        const pdfFile = new w.File([pdfBlob], 'informe-peritaje-para-cliente.pdf', { type: 'application/pdf' })

        // 4) WebSign
        if (!w.WebSign) {
          await loadScript('https://cdn.jsdelivr.net/npm/edatalia-websign@3.5.0/dist/web-sign-core.js')
        }
        if (!w.WebSign) {
          console.error('No se pudo cargar WebSign')
          return
        }

        //bloqueo de descarga automatica de PDF
        const restoreDownloadHooks = (() => {
          const origAnchorClick = w.HTMLAnchorElement?.prototype?.click
          if (!origAnchorClick) return () => {}

          w.HTMLAnchorElement.prototype.click = function () {
            try {
              if (this && typeof this.getAttribute === 'function') {
                const hasDownload = this.hasAttribute('download')
                const href = this.getAttribute('href') || ''
                if (hasDownload || href.startsWith('blob:')) {
                  return
                }
              }
            } catch (e) {
              // ignore
            }
            return origAnchorClick.apply(this, arguments)
          }

          // Restaurador
          return () => {
            w.HTMLAnchorElement.prototype.click = origAnchorClick
          }
        })()

        const prev = w.document.getElementById('asofix-ws-overlay')
        if (prev) prev.remove()

        const overlay = w.document.createElement('div')
        overlay.id = 'asofix-ws-overlay'
        overlay.innerHTML = `
          <div id="asofix-ws-modal">
            <div id="web-sign"></div>
          </div>
        `
        const css = w.document.createElement('style')
        css.textContent = `
          #asofix-ws-overlay{
            position:fixed; inset:0; background:rgba(0,0,0,.35);
            z-index:200000; display:flex; align-items:center; justify-content:center;
          }
          #asofix-ws-modal{
            width: 400px;
            height: 318px;
            background:#fff;
            border-radius:12px;
            overflow:hidden;
            box-shadow:0 16px 40px rgba(0,0,0,.35);
            position:relative;
          }
          #web-sign{ width:100%; height:100%; }
        `
        w.document.head.appendChild(css)
        w.document.body.appendChild(overlay)

        const close = () => overlay.remove()
        overlay.addEventListener('click', (e) => {
          if (e.target === overlay) close()
        })

        new w.WebSign(pdfFile, webSignConfigVerificationForClientPDF, async (event) => {
          switch (event?.type) {
            case 'signed':
            case 'signed-multiple':
              try {
                const signedBlob = event.data
                if (signedBlob) {

                  const fileToUpload = new w.File([signedBlob], 'verification-for-client-PDF-signed.pdf', { type: 'application/pdf' })
                  // Subimos el archivo y guardamos la respuesta
                  console.log('Subiendo archivo...')
                  const fileResponse = await addFile(fileToUpload)

                  // B. Si la subida fue exitosa, asociamos
                  if (fileResponse && fileResponse.id) {
                    console.log('Asociando archivo al peritaje...')

                    const fileList = [{ id: fileResponse.id }]
                    const entityName = 'PERITADOR'

                    await bulkInsertFileAssociations(fileList, entityName, requestId)
                    console.log('Asociación completada')
                  }

                  // Mostramos el PDF en la misma pestaña
                  if (fileResponse?.url) {
                    w.location.href = `${REACT_APP_IMG}/${encodeURIComponent(fileResponse.url)}`
                  } else {
                    w.location.href = w.URL.createObjectURL(signedBlob)
                  }
                }
              } catch (error) {
                console.error('[Error en proceso de guardado]', error)
                w.alert('Error al guardar o asociar el archivo.')
              } finally {
                restoreDownloadHooks()
                close()
                signBtn.style.display = 'none'
              }
              break
            case 'error':
              console.error('[WebSign error]', event)
              restoreDownloadHooks()
              close()
              break
            case 'cancel':
              restoreDownloadHooks()
              close()
              break
            default:
              break
          }
        })
      } catch (err) {
        console.error('[Firma] error:', err)
      }
    })
  return true
}
